import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Col, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useCurrency } from '../../context/currencyContext';

const themeColor = '#004aad';
const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com';

/* ================= INLINE STYLES (Payment jaisa exact) ================= */
const styles = {
  modalHeader: {
    backgroundColor: '#004AAD',
    color: '#ffffff',
    borderBottom: 'none',
    padding: '10px 15px',
    borderRadius: 0,
  },
  modalTitle: {
    fontSize: '1.3rem',
    fontWeight: 400,
    color: '#ffffff',
  },
  modalBody: {
    padding: '15px 20px',
    backgroundColor: '#ffffff',
  },
  sectionTitle: {
    color: '#004aad',
    fontSize: '1.2rem',
    fontWeight: 400,
    marginBottom: '0px',
    paddingBottom: '3px',
    borderBottom: '1px solid #004aad',
  },
  sectionTitleNoBorder: {
    color: '#004aad',
    fontSize: '1.2rem',
    fontWeight: 400,
    marginBottom: 0,
    padding: 0,
    borderBottom: 'none',
  },
  label: {
    fontWeight: 700,
    fontSize: '0.9rem',
    color: '#000000',
    minWidth: '120px',
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  required: {
    color: 'red',
    marginLeft: '2px',
  },
  greyBox: {
    backgroundColor: '#eeeeee',
    border: '1px solid #dedede',
    padding: '12px 15px',
    borderRadius: '2px',
  },
  fieldControl: {
    flex: 1,
    minWidth: 0,
  },
  inputControl: {
    height: '34px',
    fontSize: '0.9rem',
    borderRadius: '3px',
    border: '1px solid #cccccc',
    backgroundColor: '#ffffff',
    boxShadow: 'none',
  },
  datePickerWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  dateInput: {
    height: '34px',
    fontSize: '0.9rem',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    border: '1px solid #cccccc',
    borderRight: 'none',
    width: '100%',
  },
  calendarBtn: {
    height: '34px',
    width: '38px',
    backgroundColor: '#004AAD',
    color: '#ffffff',
    border: '1px solid #004AAD',
    borderTopRightRadius: '3px',
    borderBottomRightRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 0,
  },
  filterToggleBtn: {
    color: '#004aad',
    fontSize: '0.95rem',
    fontWeight: 400,
    cursor: 'pointer',
  },
  filterBoxIcon: {
    fontSize: '0.75rem',
    display: 'inline-block',
    marginRight: '2px',
  },
  filterBox: {
    backgroundColor: '#f8f9fa',
    padding: '0.75rem',
    borderRadius: '4px',
    marginBottom: '0.75rem',
    border: '1px solid #dee2e6',
  },
  filterLabel: {
    fontSize: '0.85rem',
    fontWeight: 600,
    marginRight: '8px',
    whiteSpace: 'nowrap',
  },
  tableContainer: {
    marginTop: '10px',
    maxHeight: '320px',
    overflowY: 'auto',
    border: '1px solid #eaeaea',
  },
  table: {
    marginBottom: 0,
    borderCollapse: 'collapse',
    width: '100%',
  },
  tableHead: {
    backgroundColor: '#f7f7f7',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  tableTh: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: '#000000',
    borderBottom: '1px solid #ddd',
    padding: '8px 10px',
    backgroundColor: '#f7f7f7',
  },
  tableTd: {
    fontSize: '0.88rem',
    color: '#333333',
    padding: '6px 10px',
    borderBottom: '1px solid #f0f0f0',
  },
  tableInput: {
    height: '30px',
    fontSize: '0.88rem',
    padding: '2px 8px',
    border: '1px solid #cccccc',
    borderRadius: '3px',
    textAlign: 'left',
  },
  memoLabel: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#333',
  },
  memoTextarea: {
    fontSize: '0.85rem',
    resize: 'vertical',
  },
  summaryLabel: {
    fontWeight: 600,
    color: '#333',
    fontSize: '0.95rem',
  },
  summaryValue: {
    fontWeight: 700,
    color: '#000',
    fontSize: '0.95rem',
  },
  unappliedLabel: {
    color: '#333',
    fontSize: '0.85rem',
    fontWeight: 600,
    textAlign: 'left',
  },
  unappliedValue: {
    fontWeight: 700,
    color: '#000',
    fontSize: '0.95rem',
  },
  btnCancel: {
    backgroundColor: '#004AAD',
    borderColor: '#004AAD',
    borderRadius: '3px',
    padding: '5px 18px',
    fontSize: '0.9rem',
    color: '#fff',
  },
  btnSave: {
    backgroundColor: '#004AAD',
    borderColor: '#004AAD',
    borderRadius: '3px',
    padding: '5px 22px',
    fontSize: '0.9rem',
    color: '#fff',
  },
};

/* CSS: orange checkbox + datepicker + modal width  (DESKTOP UNCHANGED)
   + SMALL SCREEN responsive rules (sirf max-width media queries mein) */
const inlineCSSTag = `
.create-payment-modal input[type="checkbox"].form-check-input:checked {
  background-color: #e65100 !important;
  border-color: #e65100 !important;
}
.create-payment-modal input[type="checkbox"].form-check-input {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
.create-payment-modal .react-datepicker-wrapper { width: 100%; }
.create-payment-modal .react-datepicker__input-container { width: 100%; }
.create-payment-modal .react-datepicker-popper { z-index: 9999 !important; }
.create-payment-modal .modal-content { border-radius: 0 !important; border: none; box-shadow: 0 5px 15px rgba(0,0,0,0.3); }
.create-payment-modal .modal-dialog { max-width: 780px !important; margin: 1.75rem auto; }
.create-payment-modal .modal-header .btn-close { filter: invert(1) grayscale(100%) brightness(200%); opacity: 0.8; }

/* =====================================================
   SMALL SCREEN  -  layout desktop jaisa, sab kuch chhota
   --pm-fs = base font size, baaki sab em mein hai
===================================================== */
@media (max-width: 767px) {
  .create-payment-modal { --pm-fs: 7px; }

  .create-payment-modal .modal-dialog {
    max-width: 97% !important;
    width: 97% !important;
    margin: 4px auto !important;
  }

  .create-payment-modal .modal-content { font-size: var(--pm-fs) !important; }

  /* ---------- header ---------- */
  .create-payment-modal .modal-header { padding: 5px 8px !important; }
  .create-payment-modal .modal-title {
    font-size: 1.6em !important;
    line-height: 1.2 !important;
  }
  .create-payment-modal .modal-header .btn-close {
    width: 0.8em !important;
    height: 0.8em !important;
    padding: 0.4em !important;
    background-size: 0.8em !important;
  }

  /* ---------- body ---------- */
  .create-payment-modal .modal-body { padding: 6px 8px !important; }

  .create-payment-modal .alert {
    font-size: 1em !important;
    padding: 3px 6px !important;
    margin-bottom: 4px !important;
  }

  .create-payment-modal .pm-section {
    font-size: 1.5em !important;
    padding-bottom: 1px !important;
    line-height: 1.2 !important;
  }

  .create-payment-modal .pm-grey { padding: 0.8em 1em !important; }

  /* rows: columns hamesha side by side */
  .create-payment-modal .row { --bs-gutter-x: 0.8em; --bs-gutter-y: 0.4em; }
  .create-payment-modal .row.mb-2 { margin-bottom: 0.5em !important; }
  .create-payment-modal .row > .col-md-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 50% !important;
  }
  .create-payment-modal .row > .col-md-5 {
    flex: 0 0 auto !important;
    width: 41.66667% !important;
    max-width: 41.66667% !important;
  }
  .create-payment-modal .row > .col-md-7 {
    flex: 0 0 auto !important;
    width: 58.33333% !important;
    max-width: 58.33333% !important;
  }
  .create-payment-modal .row > .col-md-2 {
    flex: 0 0 auto !important;
    width: 16.66667% !important;
    max-width: 16.66667% !important;
  }

  .create-payment-modal .mt-3 { margin-top: 0.6em !important; }
  .create-payment-modal .mt-2 { margin-top: 0.4em !important; }
  .create-payment-modal .mb-2 { margin-bottom: 0.4em !important; }
  .create-payment-modal .mb-1 { margin-bottom: 0.2em !important; }
  .create-payment-modal .py-3 { padding-top: 0.6em !important; padding-bottom: 0.6em !important; }
  .create-payment-modal .py-4 { padding-top: 1em !important; padding-bottom: 1em !important; }

  /* ---------- labels ---------- */
  .create-payment-modal .pm-label {
    flex: 0 0 34% !important;
    min-width: 0 !important;
    max-width: 34% !important;
    font-size: 1em !important;
    line-height: 1.15 !important;
    white-space: normal !important;
    margin-left: 0 !important;
    padding-right: 0.4em !important;
  }

  .create-payment-modal .pm-field { min-width: 0 !important; flex: 1 1 0 !important; }

  /* ---------- inputs / select / date ---------- */
  .create-payment-modal .pm-input {
    height: 2.5em !important;
    min-height: 0 !important;
    font-size: 1em !important;
    line-height: 1.2 !important;
    padding: 0 0.5em !important;
    min-width: 0 !important;
    border-radius: 2px !important;
  }
  .create-payment-modal select.pm-input {
    padding-right: 1.8em !important;
    background-size: 0.8em !important;
    background-position: right 0.4em center !important;
  }

  .create-payment-modal .pm-date-input {
    height: 2.5em !important;
    min-height: 0 !important;
    font-size: 1em !important;
    padding: 0 0.5em !important;
  }
  .create-payment-modal .pm-cal-btn {
    height: 2.5em !important;
    width: 3em !important;
    flex-shrink: 0 !important;
  }
  .create-payment-modal .pm-cal-btn svg { width: 1em !important; height: 1em !important; }

  /* react-select */
  .create-payment-modal .pm-select__control {
    min-height: 2.5em !important;
    height: 2.5em !important;
    font-size: 1em !important;
  }
  .create-payment-modal .pm-select__value-container {
    height: 2.3em !important;
    padding: 0 0.5em !important;
  }
  .create-payment-modal .pm-select__indicators { height: 2.3em !important; }
  .create-payment-modal .pm-select__indicator { padding: 0 0.3em !important; }
  .create-payment-modal .pm-select__indicator svg { width: 1.2em !important; height: 1.2em !important; }
  .create-payment-modal .pm-select__indicator-separator { display: none !important; }
  .create-payment-modal .pm-select__single-value,
  .create-payment-modal .pm-select__placeholder,
  .create-payment-modal .pm-select__input-container,
  .create-payment-modal .pm-select__input {
    font-size: 1em !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .create-payment-modal .pm-select__menu { font-size: var(--pm-fs) !important; }
  .create-payment-modal .pm-select__option {
    font-size: 1em !important;
    padding: 0.5em 0.7em !important;
  }

  /* datepicker popup */
  .create-payment-modal .react-datepicker { font-size: calc(var(--pm-fs) * 1.3) !important; }
  .create-payment-modal .react-datepicker__header { padding-top: 0.4em !important; }
  .create-payment-modal .react-datepicker__current-month,
  .create-payment-modal .react-datepicker__day-name,
  .create-payment-modal .react-datepicker__day {
    font-size: 1em !important;
    width: 1.7em !important;
    line-height: 1.7em !important;
    margin: 0.1em !important;
  }
  .create-payment-modal .react-datepicker__navigation {
    top: 0.3em !important;
    width: 2em !important;
    height: 2em !important;
  }
  .create-payment-modal .react-datepicker__navigation-icon::before {
    width: 0.6em !important;
    height: 0.6em !important;
    border-width: 1px 1px 0 0 !important;
  }
  .create-payment-modal .react-datepicker__close-icon { padding: 0 0.4em 0 0 !important; }
  .create-payment-modal .react-datepicker__close-icon::after {
    font-size: 1em !important;
    height: 1.6em !important;
    width: 1.6em !important;
    line-height: 1.4em !important;
    padding: 0 !important;
  }

  /* ---------- filter toggle + filter box ---------- */
  .create-payment-modal .pm-filter-toggle {
    font-size: 1em !important;
    margin-left: 0.5em !important;
    padding: 0 !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
  }
  .create-payment-modal .pm-filter-icon { font-size: 0.8em !important; }

  .create-payment-modal .pm-filter-box {
    padding: 0.6em 0.8em !important;
    margin-bottom: 0.6em !important;
  }
  .create-payment-modal .pm-filter-label {
    font-size: 1em !important;
    margin-right: 0.4em !important;
    white-space: nowrap !important;
    margin-bottom: 0 !important;
    flex-shrink: 0 !important;
  }
  .create-payment-modal .pm-filter-input {
    height: 2.5em !important;
    min-height: 0 !important;
    font-size: 1em !important;
    padding: 0 0.5em !important;
    min-width: 0 !important;
    border-radius: 2px !important;
  }
  .create-payment-modal .pm-filter-box .form-check {
    justify-content: flex-start !important;
    gap: 0.4em !important;
  }
  .create-payment-modal .pm-filter-box .form-check-label {
    font-size: 1em !important;
    line-height: 1.15 !important;
  }

  /* ---------- table ---------- */
  .create-payment-modal .pm-table-container {
    margin-top: 0.5em !important;
    max-height: 22em !important;
    overflow-x: hidden !important;
  }
  .create-payment-modal .pm-table-container .table-responsive { overflow-x: visible !important; }

  .create-payment-modal .pm-table {
    width: 100% !important;
    table-layout: fixed !important;
    font-size: 1em !important;
  }
  .create-payment-modal .pm-table th,
  .create-payment-modal .pm-table td {
    font-size: 1em !important;
    padding: 0.4em 0.3em !important;
    line-height: 1.15 !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
    vertical-align: middle !important;
  }
  .create-payment-modal .pm-table th:nth-child(1), .create-payment-modal .pm-table td:nth-child(1) { width: 6% !important; }
  .create-payment-modal .pm-table th:nth-child(2), .create-payment-modal .pm-table td:nth-child(2) { width: 22% !important; }
  .create-payment-modal .pm-table th:nth-child(3), .create-payment-modal .pm-table td:nth-child(3) { width: 15% !important; }
  .create-payment-modal .pm-table th:nth-child(4), .create-payment-modal .pm-table td:nth-child(4) { width: 14% !important; }
  .create-payment-modal .pm-table th:nth-child(5), .create-payment-modal .pm-table td:nth-child(5) { width: 14% !important; }
  .create-payment-modal .pm-table th:nth-child(6), .create-payment-modal .pm-table td:nth-child(6) { width: 14% !important; }
  .create-payment-modal .pm-table th:nth-child(7), .create-payment-modal .pm-table td:nth-child(7) { width: 15% !important; }

  .create-payment-modal .pm-table-input {
    height: 2.4em !important;
    min-height: 0 !important;
    font-size: 1em !important;
    padding: 0 0.3em !important;
    width: 100% !important;
  }

  /* checkboxes */
  .create-payment-modal input[type="checkbox"].form-check-input {
    width: 1.2em !important;
    height: 1.2em !important;
    margin: 0 !important;
    float: none !important;
  }
  .create-payment-modal .form-check {
    min-height: 0 !important;
    margin: 0 !important;
    padding-left: 0 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /* ---------- memo + summary ---------- */
  .create-payment-modal .pm-memo-label { font-size: 1em !important; }
  .create-payment-modal .pm-memo {
    font-size: 1em !important;
    padding: 0.3em 0.5em !important;
    line-height: 1.2 !important;
  }
  .create-payment-modal .pm-summary-row { font-size: 1em !important; }
  .create-payment-modal .pm-summary-label,
  .create-payment-modal .pm-summary-value,
  .create-payment-modal .pm-unapplied-label,
  .create-payment-modal .pm-unapplied-value {
    font-size: 1em !important;
    line-height: 1.25 !important;
  }

  /* ---------- buttons ---------- */
  .create-payment-modal .pm-btn {
    font-size: 1em !important;
    padding: 0.4em 1.2em !important;
    line-height: 1.2 !important;
    border-radius: 2px !important;
  }
  .create-payment-modal .me-2 { margin-right: 0.5em !important; }

  .create-payment-modal .spinner-border {
    width: 1.5em !important;
    height: 1.5em !important;
    border-width: 0.15em !important;
  }
}

@media (max-width: 480px) {
  .create-payment-modal { --pm-fs: 6px; }
}

@media (max-width: 360px) {
  .create-payment-modal { --pm-fs: 5px; }
}
`;

function PostingModal({ isOpen, onClose, type = 'Payment' }) {
  const [userLabId, setUserLabId] = useState('');
  const [backendError, setBackendError] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [amount, setAmount] = useState('');
  const [referenceNo, setReferenceNo] = useState('');
  const [sourceLabs, setSourceLabs] = useState([]);
  const [loadingLabs, setLoadingLabs] = useState(true);
  const [error, setError] = useState('');
  const [selectedLab, setSelectedLab] = useState('');
  const [selectedLabId, setSelectedLabId] = useState('');
  const [selectedLabName, setSelectedLabName] = useState('');
  const [memo, setMemo] = useState('');
  const [amountToApply, setAmountToApply] = useState(0);
  const [unappliedCredit, setUnappliedCredit] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentMethods] = useState([
    { id: 'cash', name: 'Cash' },
    { id: 'cc', name: 'Credit Card' },
    { id: 'bank', name: 'Bank Transfer' },
    { id: 'cheque', name: 'Cheque' },
  ]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lastStatementOnly, setLastStatementOnly] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [modalType, setModalType] = useState(type);

  // ✅ Backend-driven currency — replaces every hardcoded '£' below
  const { formatAmount } = useCurrency();

  useEffect(() => {
    setModalType(type);
  }, [type]);

  useEffect(() => {
    if (isOpen) {
      const storedUserLabId = localStorage.getItem('userLabId');
      if (storedUserLabId) {
        const cleanedId = String(storedUserLabId).trim();
        setUserLabId(cleanedId);
        setBackendError(false);
      } else {
        setError('User identification not found. Please log in again.');
      }
    }
  }, [isOpen]);
  /* ---- Helper: build auth headers (includes Bearer token if present) ---- */
  const buildAuthHeaders = (extra = {}) => {
    const headers = { userlabid: userLabId, ...extra };
    const token =
      localStorage.getItem('authToken') ||
      localStorage.getItem('token') ||
      localStorage.getItem('accessToken');
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
      border: '1px solid #ced4da',
      borderRadius: '.25rem',
      minHeight: '34px',
      height: '34px',
      boxShadow: 'none',
      '&:hover': { border: '1px solid #ced4da' },
    }),
    valueContainer: (p) => ({ ...p, height: '32px', padding: '0 8px' }),
    indicatorsContainer: (p) => ({ ...p, height: '32px' }),
    menu: (p) => ({
      ...p,
      zIndex: 9999,
      borderRadius: '.25rem',
      border: '1px solid #ced4da',
      boxShadow: '0 0.5rem 1rem rgba(0,0,0,.15)',
    }),
    option: (p, s) => ({
      ...p,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: s.isSelected ? themeColor : 'white',
      color: s.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: s.isSelected ? themeColor : '#f8f9fa',
        color: s.isSelected ? 'white' : 'black',
      },
    }),
    singleValue: (p) => ({ ...p, color: '#212529' }),
    placeholder: (p) => ({ ...p, color: '#6c757d' }),
  };

  /* ============ BACKEND LOGIC — 100% SAME, KUCH NAHI CHANGED ============ */

  useEffect(() => {
    const fetchSourceLabs = async () => {
      try {
        setLoadingLabs(true);
        setError('');
        setAuthError(false);
        if (!userLabId) {
          setLoadingLabs(false);
          return;
        }
        console.log('Fetching source labs for user:', userLabId);
        const response = await fetch(`${API_BASE_URL}/api/outsource-invoice/source-labs`, {
          headers: buildAuthHeaders(),
        });

        if (!response.ok) {
          // 401 / 403 => authentication problem, NOT a connection problem
          if (response.status === 401 || response.status === 403) {
            setAuthError(true);
            setBackendError(false);
            setError(
              'Your session is not authorized (401). Please log out and log in again, ' +
                'or contact support if the problem persists.'
            );
            setSourceLabs([]);
            return;
          }
          if (response.status === 404) {
            setSourceLabs([]);
            return;
          }
          throw new Error(`Failed to fetch labs: ${response.status}`);
        }

        const result = await response.json();
        if (result.success && Array.isArray(result.data)) {
          setSourceLabs(result.data);
          setBackendError(false);
          setAuthError(false);
          setError('');
        } else {
          setSourceLabs([]);
        }
      } catch (fetchError) {
        // Only REAL network / parse errors reach here now
        console.error('Error fetching source labs:', fetchError);
        setBackendError(true);
        setAuthError(false);
        setError(
          'Failed to connect to server. Please ensure the backend server is running.'
        );
        setSourceLabs([]);
      } finally {
        setLoadingLabs(false);
      }
    };
    if (isOpen && userLabId) fetchSourceLabs();
    else if (isOpen && !userLabId) {
      setLoadingLabs(false);
      setSourceLabs([]);
    }
  }, [isOpen, userLabId]);

  useEffect(() => {
    if (selectedLab) {
      const lab = sourceLabs.find((l) => l.labId === selectedLab);
      setSelectedLabId(lab ? lab.labId : '');
      setSelectedLabName(lab ? lab.labName : '');
    } else {
      setSelectedLabId('');
      setSelectedLabName('');
      setSelectedInvoices([]);
      setReferenceNo('');
      setAmount('');
      setAmountToApply(0);
      setUnappliedCredit(0);
      setTableData([]);
    }
  }, [selectedLab, sourceLabs]);

  useEffect(() => {
    const fetchInvoices = async () => {
      if (!selectedLabId) {
        setTableData([]);
        setSelectedInvoices([]);
        setReferenceNo('');
        setAmount('');
        setAmountToApply(0);
        setUnappliedCredit(0);
        return;
      }
      try {
        setLoadingInvoices(true);
        setError('');
        const params = new URLSearchParams();
        params.append('sourceLabId', selectedLabId);
        if (startDate) params.append('startDate', format(startDate, 'yyyy-MM-dd'));
        if (endDate) params.append('endDate', format(endDate, 'yyyy-MM-dd'));
        if (modalType === 'Payment') params.append('invoiceStatus', 'unpaid,partially_paid');
        else params.append('invoiceStatus', 'unpaid,partially_paid,overdue,pending');

        console.log('Fetching invoices with params:', params.toString());
        const response = await fetch(
          `${API_BASE_URL}/api/outsource-invoice/for-payment?${params.toString()}`,
          { headers: buildAuthHeaders() }
        );

        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            setAuthError(true);
            setError(
              'Your session is not authorized (401). Please log out and log in again.'
            );
            setTableData([]);
            setSelectedInvoices([]);
            return;
          }
          throw new Error(`Failed to fetch invoices: ${response.status}`);
        }

        const result = await response.json();
        console.log('Invoices fetched:', result);
        if (result.success && result.data) {
          const formattedInvoices = result.data.map((invoice) => ({
            ...invoice,
            originalRemaining: invoice.remaining,
            payment: invoice.remaining, // Auto-fill payment with full remaining amount
          }));
          setTableData(formattedInvoices);
          // Auto-select all invoices
          const allInvoiceIds = formattedInvoices.map((row) => row.id);
          setSelectedInvoices(allInvoiceIds);
        } else {
          setTableData([]);
          setSelectedInvoices([]);
        }
      } catch (invoiceError) {
        console.error('Error fetching invoices:', invoiceError);
        setError('Error fetching invoices: ' + invoiceError.message);
        setTableData([]);
        setSelectedInvoices([]);
      } finally {
        setLoadingInvoices(false);
      }
    };
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLabId, startDate, endDate, userLabId, modalType]);

  useEffect(() => {
    const selectedRows = tableData.filter((row) => selectedInvoices.includes(row.id));
    const invoiceNumbers = selectedRows.map((row) => row.invoiceNumber);
    setReferenceNo(invoiceNumbers.join(', '));
  }, [selectedInvoices, tableData]);

  useEffect(() => {
    const totalApplied = tableData.reduce((sum, row) => sum + parseFloat(row.payment || 0), 0);
    setAmountToApply(totalApplied);
    const numericAmount = parseFloat(amount || 0);
    if (!isNaN(numericAmount)) {
      const unapplied = numericAmount - totalApplied;
      setUnappliedCredit(unapplied > 0 ? unapplied : 0);
    } else setUnappliedCredit(0);
  }, [amount, tableData]);

  useEffect(() => {
    const calculateTotalFromSelectedInvoices = () => {
      return selectedInvoices.reduce((sum, invoiceId) => {
        const invoice = tableData.find((row) => row.id === invoiceId);
        return sum + (invoice ? parseFloat(invoice.payment || 0) : 0);
      }, 0);
    };
    if (selectedInvoices.length > 0) {
      const totalPayment = calculateTotalFromSelectedInvoices();
      setAmount(totalPayment > 0 ? totalPayment.toFixed(2) : '');
    }
  }, [selectedInvoices, tableData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'lab') setSelectedLab(value);
    else if (name === 'amount') {
      setAmount(value);
      if (value && !isNaN(parseFloat(value)) && selectedLabId) {
        const enteredAmount = parseFloat(value);
        let remainingAmount = enteredAmount;
        const newSelectedInvoices = [];
        const updatedTableData = tableData.map((row) => ({
          ...row,
          payment: 0,
          remaining: row.originalRemaining,
        }));
        const sortedInvoices = [...updatedTableData].sort((a, b) => {
          const dateA = new Date(a.invoiceDate);
          const dateB = new Date(b.invoiceDate);
          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return a.invoiceNumber.localeCompare(b.invoiceNumber);
        });
        const finalTableData = sortedInvoices.map((row) => {
          if (remainingAmount <= 0) return row;
          if (row.originalRemaining > 0) {
            if (remainingAmount >= row.originalRemaining) {
              newSelectedInvoices.push(row.id);
              remainingAmount -= row.originalRemaining;
              return { ...row, payment: row.originalRemaining, remaining: 0 };
            } else {
              newSelectedInvoices.push(row.id);
              const paymentAmount = remainingAmount;
              remainingAmount = 0;
              return {
                ...row,
                payment: paymentAmount,
                remaining: row.originalRemaining - paymentAmount,
              };
            }
          }
          return row;
        });
        setSelectedInvoices(newSelectedInvoices);
        setTableData(finalTableData);
      } else if (!value) {
        setSelectedInvoices([]);
        setTableData(
          tableData.map((row) => ({
            ...row,
            payment: 0,
            remaining: row.originalRemaining,
          }))
        );
      }
    } else if (name === 'memo') setMemo(value);
    else if (name === 'paymentMethod') setPaymentMethod(value);
  };

  const handleInvoiceSelection = (invoiceId) => {
    const isSelected = selectedInvoices.includes(invoiceId);
    if (isSelected) {
      setSelectedInvoices((prev) => prev.filter((id) => id !== invoiceId));
      setTableData((prev) =>
        prev.map((row) =>
          row.id === invoiceId ? { ...row, payment: 0, remaining: row.originalRemaining } : row
        )
      );
    } else {
      setSelectedInvoices((prev) => [...prev, invoiceId]);
      setTableData((prev) =>
        prev.map((row) =>
          row.id === invoiceId ? { ...row, payment: row.originalRemaining, remaining: 0 } : row
        )
      );
    }
  };

  const handleInvoicePaymentChange = (index, paymentValue) => {
    const updatedTableData = [...tableData];
    const row = updatedTableData[index];
    const newPayment = parseFloat(paymentValue || 0);
    if (row) {
      const maxAllowedPayment = row.originalRemaining;
      const appliedPayment = Math.min(newPayment, maxAllowedPayment);
      updatedTableData[index] = {
        ...row,
        payment: appliedPayment,
        remaining: row.originalRemaining - appliedPayment,
      };
      setTableData(updatedTableData);
    }
  };

  const handleSelectAll = () => {
    if (tableData.length === 0) return;
    const allInvoiceIds = tableData.map((row) => row.id);
    setSelectedInvoices(allInvoiceIds);
    setTableData(
      tableData.map((row) => ({ ...row, payment: row.originalRemaining, remaining: 0 }))
    );
  };

  const handleClearAll = () => {
    setSelectedInvoices([]);
    setTableData(
      tableData.map((row) => ({ ...row, payment: 0, remaining: row.originalRemaining }))
    );
    setAmount('');
  };


  const handleSave = async () => {
    if (!userLabId) {
      Swal.fire({
        title: 'Error!',
        text: 'Unable to process payment: User identification not found. Please log in again.',
        icon: 'error',
        confirmButtonColor: themeColor,
      });
      return;
    }
    if (!selectedLab || !paymentDate || !paymentMethod || !amount || !selectedInvoices.length) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields (*) and select at least one invoice.',
        icon: 'warning',
        confirmButtonColor: themeColor,
      });
      return;
    }
    const numericAmount = parseFloat(amount || 0);
    if (isNaN(numericAmount) || numericAmount <= 0) {
      Swal.fire({
        title: 'Invalid Amount',
        text: 'Please enter a valid positive amount.',
        icon: 'warning',
        confirmButtonColor: themeColor,
      });
      return;
    }
    const appliedInvoices = tableData
      .filter((row) => selectedInvoices.includes(row.id) && parseFloat(row.payment || 0) > 0)
      .map((row) => {
        const existingPaid = parseFloat(row.paid || 0);
        const newPayment = parseFloat(row.payment || 0);
        const newPaidAmount = existingPaid + newPayment;
        return {
          invoiceId: row.id,
          invoiceNumber: row.invoiceNumber,
          caseNumber: row.caseNumber,
          appliedAmount: newPayment,
          newPaidAmount: newPaidAmount,
          remainingAfterPayment: row.remaining,
        };
      });
    if (appliedInvoices.length === 0) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please enter payment amounts for selected invoices.',
        icon: 'warning',
        confirmButtonColor: themeColor,
      });
      return;
    }
    let paymentType = 'payment';
    if (modalType === 'Credit') paymentType = 'credit';
    else if (modalType === 'Debit') paymentType = 'debit';

    const paymentData = {
      sourceLabId: selectedLabId,
      sourceLabName: selectedLabName,
      amountReceived: numericAmount,
      paymentDate: format(paymentDate, 'yyyy-MM-dd'),
      paymentMethod,
      referenceNo: referenceNo.split(', ').filter(Boolean),
      memo,
      appliedInvoices,
      finalAppliedAmount: amountToApply,
      finalUnappliedAmount: unappliedCredit,
      addedBy: userLabId,
      paymentType: paymentType,
      uniquePaymentId: `OSPAY-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    };

    try {
      const paymentResponse = await fetch(`${API_BASE_URL}/api/outsource-invoice/save-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', userlabid: userLabId },
        body: JSON.stringify(paymentData),
      });
      if (!paymentResponse.ok) {
        const errorData = await paymentResponse.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to save payment: ${paymentResponse.status}`);
      }
      const responseData = await paymentResponse.json();
      if (responseData.success) {
        Swal.fire({
          title: 'Success!',
          text: `${modalType} saved successfully!`,
          icon: 'success',
          confirmButtonColor: themeColor,
        });
        handleCloseModal();
      } else throw new Error(responseData.message || 'Failed to save payment');
    } catch (error) {
      console.error('Error saving payment:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to save payment: ' + error.message,
        icon: 'error',
        confirmButtonColor: themeColor,
      });
    }
  };

  const handleCloseModal = () => {
    setSelectedLab('');
    setSelectedLabId('');
    setSelectedLabName('');
    setPaymentDate(new Date());
    setAmount('');
    setReferenceNo('');
    setMemo('');
    setTableData([]);
    setSelectedInvoices([]);
    setAmountToApply(0);
    setUnappliedCredit(0);
    setError('');
    setLoadingLabs(true);
    setPaymentMethod('');
    setStartDate(null);
    setEndDate(null);
    setLastStatementOnly(false);
    setShowFilters(false);
    setBackendError(false);
    setAuthError(false);
    setLoadingInvoices(false);
    onClose();
  };

  const CustomDateInput = React.forwardRef(({ value, onClick, name }, ref) => (
    <div style={styles.datePickerWrapper}>
      <Form.Control
        type="text"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        name={name}
        className="pm-date-input"
        style={styles.dateInput}
      />
      <button type="button" className="pm-cal-btn" style={styles.calendarBtn} onClick={onClick}>
        <svg width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H1a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
          <path d="M2.5 7a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V7z" />
        </svg>
      </button>
    </div>
  ));

  const allSelected = tableData.length > 0 && selectedInvoices.length === tableData.length;

  if (!isOpen) return null;

  return (
    <>
      <style>{inlineCSSTag}</style>

      <Modal
        show={isOpen}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        className="create-payment-modal"
      >
        <Modal.Header closeButton style={styles.modalHeader}>
          <Modal.Title style={styles.modalTitle}>
            Create New {modalType}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={styles.modalBody}>
          {error && <div className="alert alert-danger py-2">{error}</div>}
          {backendError && (
            <div className="alert alert-warning py-2">
              <strong>Connection Issue:</strong> Unable to connect to the server.
            </div>
          )}
                    {authError && (
            <div className="alert alert-warning py-2">
              <strong>Session Expired / Unauthorized:</strong> Please log out and log
              in again to continue.
            </div>
          )}
          {!userLabId && isOpen && (
            <div className="alert alert-warning py-2">
              <strong>Warning:</strong> User not identified. Please log in again.
            </div>
          )}

          <Form noValidate onSubmit={(e) => e.preventDefault()}>
            <h5 className="pm-section" style={styles.sectionTitle}>{modalType} Details</h5>

            {/* GREY BOX — Payment jaisa */}
            <div className="pm-grey" style={styles.greyBox}>
              <Row className="mb-2 align-items-center">
                <Col md={6} className="d-flex align-items-center">
                  <label className="pm-label" style={styles.label}>
                    Account <span style={styles.required}>*</span>
                  </label>
                  <div className="pm-field" style={styles.fieldControl}>
                    <Select
                      classNamePrefix="pm-select"
                      options={sourceLabs.map((lab) => ({
                        value: lab.labId,
                        label: lab.labName,
                      }))}
                      value={
                        selectedLab ? { value: selectedLab, label: selectedLabName } : null
                      }
                      onChange={(opt) =>
                        handleInputChange({
                          target: { name: 'lab', value: opt ? opt.value : '' },
                        })
                      }
                      placeholder={
                        loadingLabs
                          ? 'Loading labs...'
                          : !userLabId
                          ? 'Please log in to view labs'
                          : sourceLabs.length === 0
                          ? 'No source labs found'
                          : 'Select Lab'
                      }
                      isDisabled={loadingLabs || !userLabId || backendError}
                      isClearable
                      styles={customStyles}
                    />
                  </div>
                </Col>
                <Col md={6} className="d-flex align-items-center">
                  <label className="pm-label" style={{ ...styles.label, marginLeft: '1rem' }}>
                    Amount <span style={styles.required}>*</span>
                  </label>
                  <Form.Control
                    type="number"
                    placeholder="0.00"
                    name="amount"
                    value={amount}
                    onChange={handleInputChange}
                    step="0.01"
                    min="0"
                    className="pm-input"
                    style={styles.inputControl}
                    disabled={!userLabId || backendError}
                  />
                </Col>
              </Row>

              <Row className="mb-2 align-items-center">
                <Col md={6} className="d-flex align-items-center">
                  <label className="pm-label" style={styles.label}>
                    Payment Date <span style={styles.required}>*</span>
                  </label>
                  <div className="pm-field" style={styles.fieldControl}>
                    <DatePicker
                      selected={paymentDate}
                      onChange={(date) => setPaymentDate(date)}
                      dateFormat="d MMM yyyy"
                      customInput={<CustomDateInput name="paymentDate" />}
                      disabled={!userLabId || backendError}
                    />
                  </div>
                </Col>
                <Col md={6} className="d-flex align-items-center">
                  <label className="pm-label" style={{ ...styles.label, marginLeft: '1rem' }}>
                    Reference No.
                  </label>
                  <Form.Control
                    type="text"
                    name="referenceNo"
                    value={referenceNo}
                    readOnly
                    className="pm-input"
                    style={styles.inputControl}
                  />
                </Col>
              </Row>

              <Row className="align-items-center">
                <Col md={6} className="d-flex align-items-center">
                  <label className="pm-label" style={styles.label}>
                    Payment Method <span style={styles.required}>*</span>
                  </label>
                  <div className="pm-field" style={styles.fieldControl}>
                    <Form.Select
                      name="paymentMethod"
                      value={paymentMethod}
                      onChange={handleInputChange}
                      className="pm-input"
                      style={styles.inputControl}
                      disabled={!userLabId || backendError}
                    >
                      <option value="">Select Payment Method</option>
                      {paymentMethods.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Col>
              </Row>
            </div>

            {selectedLabId && userLabId && !backendError && (
              <>
                <div className="d-flex align-items-center mb-2 mt-3">
                  <h5 className="pm-section" style={styles.sectionTitleNoBorder}>
                    Apply to Outstanding Invoices
                  </h5>
                  <span
                    className="pm-filter-toggle"
                    style={{ ...styles.filterToggleBtn, marginLeft: '8px' }}
                    onClick={() => setShowFilters(!showFilters)}
                  >
                    (<span className="pm-filter-icon" style={styles.filterBoxIcon}>▶</span> filter)
                  </span>
                </div>

                {showFilters && (
                  <div className="pm-filter-box" style={styles.filterBox}>
                    <Row className="align-items-center g-2">
                      <Col md={5} className="d-flex align-items-center">
                        <label className="pm-filter-label" style={styles.filterLabel}>
                          From Date:
                        </label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control form-control-sm pm-filter-input"
                          placeholderText="Select Start Date"
                          isClearable
                          disabled={!userLabId || backendError}
                        />
                      </Col>
                      <Col md={5} className="d-flex align-items-center">
                        <label className="pm-filter-label" style={styles.filterLabel}>
                          To Date:
                        </label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormat="yyyy-MM-dd"
                          className="form-control form-control-sm pm-filter-input"
                          placeholderText="Select End Date"
                          isClearable
                          disabled={!userLabId || backendError}
                        />
                      </Col>
                      <Col md={2}>
                        <Form.Check
                          type="checkbox"
                          label="Last Statement"
                          checked={lastStatementOnly}
                          onChange={(e) => setLastStatementOnly(e.target.checked)}
                          style={{ fontSize: '0.85rem' }}
                          disabled={!userLabId || backendError}
                        />
                      </Col>
                    </Row>
                  </div>
                )}

                {loadingInvoices ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading invoices...</p>
                  </div>
                ) : (
                  <>
                    <div className="pm-table-container" style={styles.tableContainer}>
                      <Table className="pm-table" style={styles.table} responsive>
                        <thead style={styles.tableHead}>
                          <tr>
                            <th style={{ ...styles.tableTh, width: '40px' }}>
                              <Form.Check
                                type="checkbox"
                                checked={allSelected}
                                onChange={allSelected ? handleClearAll : handleSelectAll}
                                disabled={!userLabId || backendError}
                              />
                            </th>
                            <th style={styles.tableTh}>Description</th>
                            <th style={{ ...styles.tableTh, width: '130px' }}>
                              Invoice Date
                            </th>
                            <th style={{ ...styles.tableTh, width: '110px' }}>Total</th>
                            <th style={{ ...styles.tableTh, width: '110px' }}>Paid</th>
                            <th style={{ ...styles.tableTh, width: '110px' }}>Remaining</th>
                            <th style={{ ...styles.tableTh, width: '130px' }}>Payment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.length > 0 ? (
                            tableData.map((row, index) => (
                              <tr key={row.id || index}>
                                <td style={styles.tableTd} className="text-center">
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedInvoices.includes(row.id)}
                                    onChange={() => handleInvoiceSelection(row.id)}
                                    disabled={
                                      !userLabId ||
                                      backendError ||
                                      row.invoiceStatus === 'paid'
                                    }
                                  />
                                </td>
                                <td style={styles.tableTd}>{row.description}</td>
                                <td style={styles.tableTd}>
                                  {format(new Date(row.invoiceDate), 'd MMM yyyy')}
                                </td>
                                <td style={styles.tableTd}>
                                  {formatAmount(Number(row.total || 0))}
                                </td>
                                <td style={styles.tableTd}>
                                  {formatAmount(Number(row.paid || 0))}
                                </td>
                                <td style={styles.tableTd}>
                                  {formatAmount(Number(row.remaining || 0))}
                                </td>
                                <td style={styles.tableTd}>
                                  <Form.Control
                                    type="number"
                                    placeholder="0.00"
                                    step="0.01"
                                    min="0"
                                    max={Number(row.originalRemaining || 0)}
                                    value={row.payment === 0 ? '' : row.payment}
                                    onChange={(e) =>
                                      handleInvoicePaymentChange(index, e.target.value)
                                    }
                                    className="pm-table-input"
                                    style={styles.tableInput}
                                    disabled={
                                      !selectedInvoices.includes(row.id) ||
                                      !userLabId ||
                                      backendError ||
                                      row.invoiceStatus === 'paid'
                                    }
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center text-muted py-3">
                                No outstanding invoices found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="mt-3 align-items-center">
                      {/* Memo column — width reduced */}
                      <Col md={5}>
                        <Form.Group controlId="postingPaymentMemo">
                          <Form.Label
                            className="mb-1 pm-memo-label"
                            style={styles.memoLabel}
                          >
                            Memo / Note
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="memo"
                            value={memo}
                            onChange={handleInputChange}
                            placeholder="Optional payment details or reference notes..."
                            className="pm-memo"
                            style={styles.memoTextarea}
                            disabled={!userLabId || backendError}
                          />
                        </Form.Group>
                      </Col>
                      {/* Summary column — width increased */}
                      <Col md={7}>
                        {/* Amount to Apply row */}
                        <div
                          className="d-flex justify-content-between align-items-center mb-1 pm-summary-row"
                          style={{ fontSize: '0.95rem' }}
                        >
                          <span className="pm-summary-label" style={styles.summaryLabel}>
                            Amount to Apply:
                          </span>
                          <span className="pm-summary-value" style={styles.summaryValue}>
                            {formatAmount(amountToApply)}
                          </span>
                        </div>

                        {/* Unapplied credit row — exactly 2 lines */}
                        <div className="d-flex justify-content-between align-items-start">
                          <span
                            className="pm-unapplied-label"
                            style={{
                              ...styles.unappliedLabel,
                              lineHeight: '1.3',
                            }}
                          >
                            Credit amount exceeding the outstanding
                            <br />
                            invoices total creates a new unapplied credit:
                          </span>
                          <span
                            className="pm-unapplied-value"
                            style={{
                              ...styles.unappliedValue,
                              whiteSpace: 'nowrap',
                              marginLeft: '8px',
                            }}
                          >
                            {formatAmount(unappliedCredit)}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {/* Footer buttons inside body — Payment jaisa */}
            <div className="d-flex justify-content-end mt-3">
              <Button
                variant="secondary"
                className="me-2 pm-btn"
                style={styles.btnCancel}
                onClick={handleCloseModal}
              >
                Cancel
              </Button>
              <Button
                className="pm-btn"
                style={{
                  ...styles.btnSave,
                  ...(!userLabId || backendError || loadingInvoices
                    ? { opacity: 0.6, cursor: 'not-allowed' }
                    : {}),
                }}
                onClick={handleSave}
                disabled={!userLabId || backendError || loadingInvoices}
              >
                Save {modalType}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PostingModal;